import { Box, Text, Flex } from '@chakra-ui/react';

export const Badge = ({ children, ...props }) => {
  return (
    <Box
      borderRadius="6px"
      p="2px 6px"
      fontSize="sm"
      fontWeight="medium"
      color="var(--kula-dark-secondary-950, #161616)"
      {...props}
    >
      {children}
    </Box>
  );
};

export const Connectedbadge = ({ badgeText = 'Connected', ...props }) => {
  return (
    <Flex
      borderRadius="50px"
      p="6px 12px"
      fontSize="sm"
      fontWeight="medium"
      bg="var(--kula-dark-secondary-50, #ECFDF3)"
      alignItems="center"
      gap="6px"
      {...props}
    >
      <Box bg="#12B76A" w="8px" h="8px" borderRadius="full"></Box>
      <Text color="var(--kula-colors-status-success-fg, #027A48)">
        {badgeText}
      </Text>
    </Flex>
  );
};
